<template>

  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">

          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
             {{title}}
          </h3>
        </div>

      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tableData">
        <template slot="columns">

          <th>Owner Details</th>
          <th>Number Of Cars</th>
          <th>Status</th>
        </template>

        <template slot-scope="{row}">

          <th scope="username">
            <div class="media align-items-center">
              <a href="#" class="avatar rounded-circle mr-3">
                <img alt="Car Image" src="/img/theme/team-4-800x8001.jpg">
              </a>
              <div class="media-body">
                <h1><span class="name mb-0 text-sm">{{row.fullName}}</span></h1>
                Email: {{row.email}}
                <br>
                Phone: {{row.phoneNumber}}
                <br>
                Addr: {{row.address}}
              </div>
            </div>
          </th>

          <td v-if="row.cars" class="">
            <h1>{{row.cars.length}}</h1>
            <button @click="handleViewOwnerCarsAndStatistics(row, `/dashboard/view-single-owner-stats/${row.id}`)" v-show="row.cars.length === 1" href="#" class="btn btn-info">View Car Details</button>
            <button @click="handleViewOwnerCarsAndStatistics(row, `/dashboard/view-single-owner-stats/${row.id}`)" v-show="row.cars.length > 1" href="#" class="btn btn-info">View Details of All Cars</button>
          </td>

          <td v-else class="cars">
              0
          </td>

          <td class="status">
            <badge :type="statusColor(row.status)">{{row.status}}</badge>
          </td>


        </template>

      </base-table>
    </div>

    <div class="row">
        <div class="col-md-4">
            <modal :show.sync="modals.modal3"
                   body-classes="p-0"
                   modal-classes="modal-dialog-centered modal-sm">
                <card type="secondary" shadow
                      header-classes="bg-white pb-5"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <template>
                        <div class="text-center text-muted mb-4">
                            <h5>Select A Car To Attach To Name Here</h5>
                        </div>
                        <form role="form">
                           <multiselect
                                 v-model="selectedCarToAttach"
                                 deselect-label="Currently Selected"
                                 track-by="modelName"
                                 label="modelName"
                                 placeholder="Select One"
                                 :options="allCars">
                            </multiselect>
                            <div class="text-center">
                                <base-button @click="handleAttachCarToOwner" type="primary" class="my-4">Submit</base-button>
                            </div>
                        </form>
                    </template>
                </card>
            </modal>
        </div>
        <div class="col-md-4">
            <modal :show.sync="modals.modal2"
                   body-classes="p-0"
                   modal-classes="modal-dialog-centered modal-sm">
                <card type="secondary" shadow
                      header-classes="bg-white pb-5"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <template>
                        <div class="text-center text-muted mb-4">
                            <h2>Update Owner Status</h2>
                        </div>
                        <form role="form">
                           <multiselect v-model="selectedOwnerStatus" :options="updateOwnerStatusList"></multiselect>
                            <div class="text-center">
                                <base-button @click="handleUpdateOwnerStatus" type="success" class="my-4">Submit</base-button>
                            </div>
                        </form>
                    </template>
                </card>
            </modal>
        </div>
    </div>

  </div>
</template>
<script>
import Modal from '@/components/Modal'
import { mapState } from 'vuex'
import store from '@/store/store'

  export default {
    created() {
      if (store.state.owner.owners.length < 1) {
        store.dispatch('owner/fetchOwners').then(() =>{
            console.log(this.owner.owner );
          });
      }
    },
    computed: {
      ...mapState(['owner']),
      tableData(){
        return this.owner.owners
      },
      tableDataIsEmpty(){
        return this.tableData.length < 1
      },
    },
    components: {
        Modal,
    },
    props: {
      type: {
        type: String
      },
      title: String
    },
    methods: {
      statusColor(stat){
        if (stat === "active") {
          return "success"
        } else {
          return "danger"
        }
      },
      handleAttachCarToOwner() {
        // UpdateOwnerInfo By Adding A New Car
        //alert(JSON.stringify(this.selectedCarToAttach));
      },
      handleViewOwnerCarsAndStatistics(data, route){
        store.dispatch('owner/setOwnerCarsAndStatistics',  data)
        this.$router.push({
          path: route,
        });
      },
      handleUpdateOwnerStatus() {
        store.dispatch('owner/editOwner', {
          ownerId: this.owner.owner.id,
          ownerDataToUpdate: { status: this.selectedOwnerStatus }
        })
        .then((owner) =>{
          // notify
          this.modals.modal2 = false;
          this.$notify({
            type: 'success',
            title: `Status Updated Successfully. Changed To ${owner.status}`,
          });
        }).catch((error) => {
          // this.owner.status = currentOwner.status;
          this.modals.modal2 = false;
          this.$notify({
            type: 'danger',
            title: `Status Failed To Update: Error => ${error.message}`,
          });
        });
      },
      handleOwnerActions(id, route){
        store.dispatch('owner/fetchOwnerById', id).then((owner) =>{
          console.log("==== fetched ====", owner);
          this.$notify({
            type: 'success',
            title: `Full Details For ${owner.fullName}`,
          });
          this.$router.push({
            path: route,
          });
        });
      },
      handleOpenChangeOwnerStatusModal(id){
        this.modals.modal2 = true
        store.dispatch('owner/fetchOwnerById', id)
        .then((owner) =>{
          console.log("==== fetched ====", owner);
          this.selectedOwnerStatus = this.owner.owner.status;
        })
      },
    },
    data() {
      return {
        selectedCarToAttach: {},
        selectedOwnerStatus: '',
        allCars: [
          {
            id: 'carIdOne',
            modelName: 'KIA Morning Lx 2008',
            modelYearL: '2008',
            carNumber: 'GS 1234-20',
          },
          {
            id: 'carIdTwo',
            modelName: 'KIA Morning Lx 2009',
            modelYearL: '2008',
            carNumber: 'GS 1234-20',
          },
          {
            id: 'carIdThree',
            modelName: 'KIA Morning Lx 2010',
            modelYearL: '2008',
            carNumber: 'GS 1234-20',
          },
          {
            id: 'carIdFour',
            modelName: 'KIA Morning Lx 2011',
            modelYearL: '2008',
            carNumber: 'GS 1234-20',
          },

        ],
        modals:{
          modal1: false,
          modal2: false,
          modal3: false,
        },
        carForm: {
          currentDriver: ''
        },
        allDriversList: [
          'Driver 1',
          'Driver 2',
          'Driver 3',
        ],
        updateOwnerStatusList: [
          'active',
          'inactive',
        ],
        total: 30,
      }
    },
  }
</script>
<style>
</style>
